export default __webpack_public_path__ + "static/media/rnr-sports-table-20.22d87c7a.webp";